import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import AdminPage from "./pages/Admin";
import BroadcastPage from "./pages/Broadcast";
import DraftPage from "./pages/Draft";
import ManagerDetailPage from "./pages/ManagerDetail";
import PreviewPage from "./pages/Preview";
import SeasonTrackerPage from "./pages/SeasonTracker";
import TransactionsPage from "./pages/Transactions";
import UniversePage from "./pages/Universe";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<SeasonTrackerPage />} />
        <Route path="/manager/:name" element={<ManagerDetailPage />} />
        <Route path="/draft" element={<DraftPage />} />
        <Route path="/universe" element={<UniversePage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        {/* Internal design preview — dev only, never reachable in production. */}
        {import.meta.env.DEV && <Route path="/preview" element={<PreviewPage />} />}
        <Route path="/broadcast" element={<BroadcastPage />} />
        <Route path="/broadcast/draft" element={<BroadcastPage view="draft" />} />
        <Route path="/broadcast/race" element={<BroadcastPage view="race" />} />
        <Route
          path="*"
          element={
            <div className="py-20 text-center text-muted">Page not found.</div>
          }
        />
      </Routes>
    </Layout>
  );
}
